import {
  motion,
  useSpring,
  useTransform,
  useViewportScroll,
} from "framer-motion";
import { useCallback, useEffect, useRef, useState } from "react";
import { useEffectOnce, useMount, useWindowSize } from "react-use";
import styled from "styled-components";
import { useResizeObserver } from "../lib/hooks/useResizeObserver";

interface ScrollTransformProps {
  moveFactor: any[];
  startOffset?: number;
  direction?: "x" | "y";
  debug?: boolean;
}

const Static = styled.div`
  position: relative;
  /* background-color: pink; */
`;
const XDate = styled(motion.div)``;

export const ScrollTransform: React.FC<ScrollTransformProps> = ({
  moveFactor,
  startOffset = 0,
  children,
  direction = "x",
  debug,
}) => {
  const [elY, setElY] = useState(1);
  const [elHeight, setElHeight] = useState(1);
  const elRef = useRef<HTMLElement>(null);

  const { height } = useWindowSize();
  const { scrollY } = useViewportScroll();

  // const dateMotion = useTransform(scrollY, (d) => {
  //   const bottom = d + height;
  //   return bottom < y ? 0 : (y - bottom) * moveFactor + startOffset;
  // });

  const onScreenRatio = useTransform(scrollY, (scrollY) => {
    const scrollYBottom = scrollY + height;
    const elBottom = elY + elHeight;

    // console.log(elBottom);
    const comp = Math.min(elBottom, height);
    if (scrollYBottom < elY) {
      return 0;
    }
    if (scrollY > elBottom) {
      return 1;
    }

    // if (debug) {
    //   console.log(elBottom);
    // }

    // console.log((scrollYBottom - elY) / (height + elHeight));
    return elBottom < height
      ? scrollY / elBottom
      : (scrollYBottom - elY) / (height + elHeight);
  });

  const physics = { damping: 15, mass: 0.27, stiffness: 55 }; // easing of smooth scroll
  const spring = useSpring(onScreenRatio, physics); // apply easing to the negative scroll value
  const dateMotion = useTransform(spring, [0, 1], moveFactor);

  // useEffectOnce(() => {
  //   const timeout = setTimeout(() => {
  //     if (elRef.current) {
  //       setElY(elRef.current.getBoundingClientRect().top + scrollY.get());
  //       setElHeight(elRef.current.getBoundingClientRect().height);
  //     }
  //   }, 2000);
  //   // return clearTimeout(timeout);
  // });

  const resizePageHeight = useCallback(() => {
    elRef.current &&
      setElY(elRef.current.getBoundingClientRect().top + scrollY.get());
    elRef.current && setElHeight(elRef.current.getBoundingClientRect().height);
  }, [scrollY]);

  useResizeObserver(elRef, resizePageHeight);

  return (
    <Static ref={elRef as any}>
      <XDate style={direction === "x" ? { x: dateMotion } : { y: dateMotion }}>
        {children}
      </XDate>
    </Static>
  );
};
